import React, { Component } from 'react';
import ChatWindow from './ChatWindow';
import launcherIcon from 'Icons/logo-no-bg.svg';
import launcherIconActive from 'Icons/close-icon.png';

class Launcher extends Component {

  constructor() {
    super();
    this.state = {
      launcherIcon,
      isOpen: false
    };
  }
  timer = null;
  handleClick() {
    if (this.props.handleClick !== undefined) {
      this.props.handleClick();
    } else {
      this.setState({
        isOpen: !this.state.isOpen,
      }, () => {
        if(this.state.isOpen) {
          clearTimeout(this.timer);
        }
        this.props.clearChatMessagesCount();
        this.props.setIsOpen(this.state.isOpen);
      });
    }
  }

  toggleTitle = () => {
    const { newMessagesCount } = this.props;
    if(document.title.indexOf("messages") > -1) {
      document.title = "TEG"
    } else {
      document.title = `TEG | You Have New Messages (${newMessagesCount})`;
    }
  }

  componentDidUpdate() {
    const { newMessagesCount } = this.props;    
    if(newMessagesCount > 0 && !this.state.isOpen) {
        clearInterval(this.timer);
        this.timer = setInterval(this.toggleTitle, 1000);   
    } else {
      document.title = `TEG`;
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }
  
  render() {
    const isOpen = this.props.hasOwnProperty('isOpen') ? this.props.isOpen : this.state.isOpen;
    const classList = [
      'sc-launcher',
      (isOpen ? 'opened' : ''),
    ];
    return (
      <div>
        <div>
        </div>
        <div className={classList.join(' ')} onClick={this.handleClick.bind(this)}>
          <MessageCount count={this.props.newMessagesCount} isOpen={isOpen} />
          <img className={"sc-open-icon"} src={launcherIconActive} />
          <img className={"sc-closed-icon"} src={launcherIcon} />
        </div>
        {isOpen && <ChatWindow
          messageList={this.props.messageList}
          onUserInputSubmit={this.props.onMessageWasSent}
          agentProfile={this.props.agentProfile}
          isOpen={isOpen}
          onClose={this.handleClick.bind(this)}
          showEmoji={this.props.showEmoji}
          userId={this.props.userId}
          loadPreviousMessages={this.props.loadPreviousMessages}
          chatMenu={this.props.chatMenu}
          onSelectUser={this.props.onSelectUser}
        />}
      </div>
    );
  }
}

const MessageCount = (props) => {
  if (props.count === 0 || props.isOpen === true) { return null }
  return (
    <div className={"sc-new-messsages-count"}>
      {props.count}
    </div>
  )
}

Launcher.defaultProps = {
  newMessagesCount: 0,
  showEmoji: true
}

export default Launcher;
